import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { SelectInput } from '@PipelineDeals/shared-react-components'

const DealSelector = ({ selectedDeal, handleDealClick, deals }) => {
  const { t } = useTranslation()
  const makeSelection = (selectedValue) => {
    if (!selectedValue) {
      handleDealClick(null)
      return
    }
    handleDealClick(selectedValue.value)
  }

  const personOptions = deals.map(deal => ({ value: deal.id, label: deal.name }))
  const selectedPersonObject = personOptions.find(person => person.value === selectedDeal)

  return (
    <SelectInput
      label={t('common.labels.deal')}
      options={personOptions}
      onChange={makeSelection}
      value={selectedPersonObject}
      placeholder={t('components.dealSelector.placeholder')}
      clearable
      searchable
      noOptionsMessage={() => t('components.dealSelector.noDealsMatch')}
    />
  )
}

DealSelector.propTypes = {
  deals: PropTypes.array.isRequired,
  handleDealClick: PropTypes.func.isRequired,
  selectedDeal: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ])
}

DealSelector.defaultProps = {
  displayDealsHeader: false,
  displayAddNewDeal: false,
  noneOption: true,
  pullRight: false,
  selectFirstDealByDefault: true
}

export default DealSelector
